export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9356.199ec84a.jpg";